import { useContext } from "@nuxtjs/composition-api";
function useMenus() {
  const MENUS_STORE_MODULE_NAME = "menus";
  const { store } = useContext();
  const getMenusFromStoreByGetter = (getterName) => {
    const siteInfoGettersToStoreGettersMap = {
      menuTop: `${MENUS_STORE_MODULE_NAME}/menuTop`,
      menuMain: `${MENUS_STORE_MODULE_NAME}/menuMain`,
      menuFooter: `${MENUS_STORE_MODULE_NAME}/menuFooter`,
      menuBottom: `${MENUS_STORE_MODULE_NAME}/menuBottom`,
      menuLocations: `${MENUS_STORE_MODULE_NAME}/getLocations`
    };
    return store.getters[siteInfoGettersToStoreGettersMap[getterName]];
  };
  const menuTop = getMenusFromStoreByGetter("menuTop");
  const menuMain = getMenusFromStoreByGetter("menuMain");
  const menuFooter = getMenusFromStoreByGetter("menuFooter");
  const menuBottom = getMenusFromStoreByGetter("menuBottom");
  const menuLocations = getMenusFromStoreByGetter("menuLocations");
  return {
    menuTop,
    menuMain,
    menuFooter,
    menuBottom,
    menuLocations
  };
}
export {
  useMenus as default
};
